export default "__VITE_PUBLIC_ASSET__62206224__"